import { Print } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import * as QRCodeLib from "qrcode";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikForm from "../../../commons/formik/formikForm";
import FeatureLabel from "../../../commons/labels/FeatureLabel";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledQr } from "../../../styled/qr";

const QRForm = ({ handlePrintFile }) => {
  const url = window.location.origin;
  const provider = useSelector((state) => state.providers.selectedProvider);
  const branches = useSelector((state) => state.appointments.getBranches);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [qrVisible, setQrVisible] = useState(false);
  const [qrBase64, setQrBase64] = useState(null);

  useEffect(() => {
    if (branches.data.length === 1) {
      setSelectedBranch(branches.data[0].id);
      setQrVisible(true);
    }
  }, [branches.data]);

  const initialValues = {
    sucursal: branches.data?.length === 1 ? branches.data[0].id : null,
  };

  const handleGenerateQR = (value) => {
    setSelectedBranch(value.sucursal);
    setQrVisible(true);
  };

  const handlePrint = () => {
    const qr = `${url}${CONFIG.path}/attendance?provider=${provider}&sucursal=${selectedBranch}`;
    generateQrBase64(qr);
  };

  const generateQrBase64 = (value) => {
    QRCodeLib.toDataURL(value, { width: 256, margin: 0 }, (error, url) => {
      handlePrintFile(url, selectedBranch);
    });
  };

  return (
    <>
      <StyledQr.Title>Asistencia a turnos mediante codigo QR</StyledQr.Title>
      <StyledQr.StyledPaper>
        {!branches.isFetching ? (
          branches.data?.length === 0 ? (
            <StyledQr.ErrorText>
              No se hallaron sucursales asociadas al Prestador. Notifique al
              administrador de Sistema.
            </StyledQr.ErrorText>
          ) : (
            <>
              <FormikForm initialValues={initialValues} onSubmit={handleGenerateQR}>
                {({ setFieldValue }) => (
                  <StyledQr.FormContainer>

                    <StyledQr.AutocompleteContainer>
                      <FormikAutocomplete
                        name="sucursal"
                        label="Sucursal"
                        variant="standard"
                        options={branches.data}
                        disabled={branches.data.length === 1}
                        value={selectedBranch}
                        callBack={(event, newValue) => {
                          setQrVisible(!!newValue);
                        }}
                        renderOption={(option) => `${option.nombre}`}
                      />
                    </StyledQr.AutocompleteContainer>
                    <StyledQr.StyledButton
                      variant="contained"
                      type="submit"
                      color="primary"
                      disabled={branches.data?.length === 1}>
                      Generar QR
                    </StyledQr.StyledButton>
                  </StyledQr.FormContainer>
                )}
              </FormikForm>
              {qrVisible && selectedBranch ? (
                <>
                  <StyledQr.QRContainer>
                    <QRCode
                      value={`${url}${CONFIG.path}/attendance?provider=${provider}&sucursal=${selectedBranch}`}
                      size={256}
                      bgColor="#ffffff"
                      fgColor="#000000"
                    />
                  </StyledQr.QRContainer>
                  <StyledQr.ButtonContainer container spacing={1}>
                    <Grid item>
                      <FeatureLabel
                        labelText="IMPRIMIR"
                        icon={<Print />}
                        onClick={handlePrint}
                        tooltipText="Imprimir archivo"
                        disabled={!qrVisible}
                      />
                    </Grid>
                  </StyledQr.ButtonContainer>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    margin: 50,
                  }}>
                  <Typography>
                    Seleccione una sucursal para generar el QR
                  </Typography>
                </Box>
              )}
            </>
          )
        ) : (
          <CircularLoading />
        )}
      </StyledQr.StyledPaper>
    </>
  );
};

export default QRForm;
